import {AbstractEvent} from "@/modules/base/events";
import {Stadium} from "@/modules/stadium/entity";

export class BeforeFoundationFinishedEvent extends AbstractEvent {
  constructor(
    public stadium: Stadium,
  ) {
    super();
  }
}